import { render } from "./DocDeletionConfirmation.vue?vue&type=template&id=4134a47d&scoped=true"
import script from "./DocDeletionConfirmation.vue?vue&type=script&lang=js"
export * from "./DocDeletionConfirmation.vue?vue&type=script&lang=js"

import "./DocDeletionConfirmation.vue?vue&type=style&index=0&id=4134a47d&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4134a47d"]])

export default __exports__